import config from '../config/index';
import { request } from './api';
export default {
  loadPromotionInfo(newsId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/news',
      data: { newsId: newsId },
      transformResponse: function (res) {
        if (res && res.returncode === 0 && res.result) {
          const rs = res.result;
          var imageSrc = '';
          var imageArray = [];
          if (rs.Images && rs.Images.length > 0) {
            imageSrc = rs.Images[0].replace('http://', 'https://');
            imageArray = rs.Images;
          }
          rs.imageSrc = imageSrc;
          rs.imageArray = imageArray;
          return { returncode: 0, message: '', result: rs };
        } else {
          return {
            returncode: 1,
            message: 'res 返回不正确！',
            result: res.result,
          };
        }
      },
    });
  },
};
